import React from 'react';

const DriversReport: React.FC = () => {
	return (
		<div style={{ height: '100%' }} className='card p-align-center p-justify-center'>
			<form className='p-grid p-fluid'>
				<div className='p-field p-col-12 p-md-2'>
					<label htmlFor='agency'>Unidade</label>
				</div>
			</form>
		</div>
	);
};

export default DriversReport;
